import { defineMessages } from 'react-intl';

import { Switch } from '#src/atoms/inputs/Switch/index.tsx';
import { SettingsSection } from '#src/components/settings/SettingsSection/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { LIFECYCLE, useLifecycle } from '#src/hooks/useLifecycle.ts';

const messages = defineMessages({
  title: {
    defaultMessage: '3D preview',
  },
  description: {
    defaultMessage: 'Always disable 3D preview',
  },
});

export const Disable3D = () => {
  const { currentUser } = useCurrentUserContext();
  const { update, lifecycle } = useLifecycle();
  const disable3D = lifecycle?.disable3D;

  if (!currentUser) return null;

  return (
    <SettingsSection
      title={messages.title}
      description={messages.description}
      toggleButton={
        <Switch
          checked={disable3D}
          onChange={() => {
            update(LIFECYCLE.disable3D, !disable3D);
          }}
        />
      }
    />
  );
};
